import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { EntTerritorialsUnits } from "../../../models/handBooks/territorialsUnits";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const territorialUnitsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getTerritorialUnitsList: builder.query<ResponseDataGet<EntTerritorialsUnits>, EntTerritorialUnitsFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.territorialunits }/get-all/page`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTerritorialUnitsShortList: builder.query<ResponseDataGet<EntTerritorialsUnits>, EntTerritorialUnitsFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.territorialunits }/get-all/short`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTerritorialUnitsGetpolygonsList: builder.query<ResponseDataGet<EntTerritorialsUnits>, EntTerritorialUnitsFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.territorialunits }/get-all/polygons`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTerritorialUnitsById: builder.query<ResponseDataTest<EntTerritorialsUnits>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.territorialunits }/${ id }`,
		method: 'GET'
	  })
	}),
	addTerritorialUnits: builder.mutation<ResponseDataTest<EntTerritorialsUnits>, EntTerritorialsUnits>({
	  query: (body) => ({
		url: `${ Paths.handbooks.territorialunits }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editTerritorialUnits: builder.mutation<ResponseDataTest<EntTerritorialsUnits>, EntTerritorialsUnits>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.territorialunits }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteTerritorialUnits: builder.mutation<ResponseDataTest<EntTerritorialsUnits>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.territorialunits }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetTerritorialUnitsListQuery,
  useLazyGetTerritorialUnitsShortListQuery,
  useGetTerritorialUnitsGetpolygonsListQuery,
  useAddTerritorialUnitsMutation,
  useEditTerritorialUnitsMutation,
  useDeleteTerritorialUnitsMutation
} = territorialUnitsApi;
